import { render } from "./AgendaCitasConColecciones.vue?vue&type=template&id=7e2bcb4d&scoped=true"
import script from "./AgendaCitasConColecciones.vue?vue&type=script&lang=ts"
export * from "./AgendaCitasConColecciones.vue?vue&type=script&lang=ts"

import "./AgendaCitasConColecciones.vue?vue&type=style&index=0&id=7e2bcb4d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e2bcb4d"

export default script